/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useMemo, useCallback } from 'react'
import { UserContext } from 'stores/UserStore'
import vallourecServices from 'api/vallourecServices'
import _ from 'lodash'
import { descompressResponse } from 'utils/decompress'
import { toast } from 'react-toastify'

export const VallourecServicesDataContext = React.createContext({})

export const VallourecServicesDataProvider = ({ children }) => {

  const { idToken, user } = useContext(UserContext)
  const [isLoading, setLoading] = useState(false)
  const [filters, setFilters] = useState({})
  const [tagsFilters, setTagsFilters] = useState({})
  const [selectedItem, setSelectedItem] = useState()
  const [loadingLista, setLoadingLista] = useState(true)
  const [specificList, setSpecificList] = useState("")
  const [infoSpecific, setInfoSpecific] = useState([])
  const [totalPieces, setTotalPices] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const [pieceSpecific, setPieceSpecific] = useState([])
  const [specificPage, setSpecificPage] = useState(0)
  const [loadingListasSalvas, setLoadingListasSalvas] = useState(true)
  const [totalPaginas, setTotalPaginas] = useState(0)
  const [totalList, setTotalList] = useState("")
  const [listas, setListas] = useState([])
  const [qtdTags, setQtdTags] = useState(0)
  const [openFiltro, setOpenFiltro] = useState(false)
  const [searchApplied, setSearchApplied] = useState({ key: "ippn", value: null })
  const [filterApplied, setFilterApplied] = useState([])

  const getAllTags = (data) => {
    let soma = 0
    data.map((item) => {
      return soma += Number(item.qtd)
    })
    setQtdTags(soma)
  }

  const getLists = async (page) => {
    await vallourecServices.getLists(idToken, { uuid: user.username, page: page }).then((data) => {
      const descompressData = descompressResponse(data)
      if (descompressData !== undefined) {
        setTotalList(descompressData.totalListas)
        if (totalList === 0) {
          toast.warn("Não há listas salvas")
        }
        setTotalPaginas(descompressData.totalPaginas)
        setListas(descompressData.listas)
        getAllTags(descompressData.listas)
        setLoadingListasSalvas(false)
      }
    }).catch(e => {
      toast.error(e.message)
    })
  }

  const getSpecificList = async (page) => {
    setLoadingLista(true)
    await vallourecServices.getSpecificLists(idToken, { uuid: specificList, page: page, totalPieces: totalPieces }).then((data) => {
      data = data.body ? data.body : data
      const descompressData = descompressResponse(data)
      if (descompressData !== undefined) {
        setInfoSpecific(descompressData.lista)
        setPieceSpecific(descompressData.pecas)
        // setTotalPices(descompressData.totalPecas)
        setTotalPages(descompressData.totalPaginas)
        setLoadingLista(false)
      }
    })
  }

  const uploadManualData = useCallback((upload) => new Promise((resolve, reject) => {
    setLoading(true)
    vallourecServices.uploadManualData(idToken, upload).then(data => {
      setLoading(false)
      resolve()
    }).catch(e => {
      reject(e)
    })
  }), [idToken])

  const filteredVallourecServicesData = useMemo(() => {
    for (const key of Object.keys(filters)) {
      if (filters[key].length === 0) {
        delete filters[key]
      }
    }
    const filteredTableData = _.filter(listas, item => {
      let match = true
      _.chain(filters)
        .pickBy(filter => filter.length > 0)
        .each((filter, key) => {
          const itemValue = _.get(item, key)
          match = match && _.includes(filter, itemValue)
        })
        .value()
      return match
    })
    return {
      ...listas,
      listas: filteredTableData
    }
  }, [filters, listas])

  const filteredVallourecServicesTags = useMemo(() => {
    for (const key of Object.keys(tagsFilters)) {
      if (tagsFilters[key].length === 0) {
        delete tagsFilters[key]
      }
    }
    const filteredTableData = _.filter(pieceSpecific, item => {
      let match = true
      _.chain(tagsFilters)
        .pickBy(filter => filter.length > 0)
        .each((filter, key) => {
          const itemValue = _.get(item, key)
          match = match && _.includes(filter, itemValue)
        })
        .value()
      return match
    })
    return {
      ...pieceSpecific,
      pieceSpecific: filteredTableData
    }
  }, [tagsFilters, pieceSpecific])

  return (
    <VallourecServicesDataContext.Provider value={{
      listas,
      qtdTags,
      getLists,
      isLoading,
      totalList,
      totalPages,
      totalPieces,
      loadingLista,
      infoSpecific,
      totalPaginas,
      pieceSpecific,
      getSpecificList,
      uploadManualData,
      loadingListasSalvas,
      filters, setFilters,
      openFiltro, setOpenFiltro,
      tagsFilters, setTagsFilters,
      filteredVallourecServicesTags,
      filteredVallourecServicesData,
      selectedItem, setSelectedItem,
      filterApplied, setFilterApplied,
      searchApplied, setSearchApplied,
      setSpecificList, setSpecificPage,
      setTotalPices, specificPage
    }}>
      {children}
    </VallourecServicesDataContext.Provider>
  )
}